module.exports = __webpack_public_path__ + "05f270cc8bc598e106f4a0b3b5d74b86.svg";